import Dialog from '#lib/components/dialog.jsx';
import Button from '#lib/components/button.jsx';

export default function UnsavedChangesModal(props) {
    const { isOpen, onClose, onConfirm } = props;

    return (
        <Dialog isOpen={isOpen} onClose={onClose}>
            <Dialog.Panel className="flex flex-col space-y-4 max-w-[450px] z-50 gap-2">
                <div className="pr-4">
                    <Dialog.Title> {_t.global.unsavedChangesTitle()} </Dialog.Title>
                    <Dialog.CloseButton />
                </div>

                <div>{_t.global.unsavedChangesDescription()}</div>

                <Button look="primary" onClick={onConfirm}>
                    {_t.global.confirm()}
                </Button>
            </Dialog.Panel>
        </Dialog>
    );
}
